/** Traps spaces for required fields to prevent empty input.
 *
 * For example, " " will be considered invalid. */
export const trapSpacesForRequiredFields = (value, error) => {
  return value?.trim() ? true : error
}
